"use strict";
/**
 * Remove `sys` data objects in contentful object recursively.
 * @param {object} data
 * @returns {object}
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeSysKey = void 0;
const removeSysKey = (obj) => {
    if (Array.isArray(obj)) {
        return obj
            .map((item) => (0, exports.removeSysKey)(item))
            .filter((item) => !(item && typeof item === 'object' && 'sys' in item));
    }
    if (typeof obj === 'object' && obj !== null) {
        return Object.entries(obj).reduce((acc, [key, value]) => {
            if (key === 'sys') {
                return acc;
            }
            acc[key] = (0, exports.removeSysKey)(value);
            return acc;
        }, {});
    }
    return obj;
};
exports.removeSysKey = removeSysKey;
//# sourceMappingURL=removeSysKey.js.map